if (typeof ProductTabs !== 'function') {
	class ProductTabs extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				tabs: '.product-tab',
				headings: '.product-tab__heading',
				close: '.product-tabs__close',
			};

			this.classes = {
				hasVisibleTab: 'tab-visible',
				active: 'product-tab--active',
			};

			// Elements
			this.tabs = this.querySelectorAll(this.selectors.tabs);
			this.headings = this.querySelectorAll(this.selectors.headings);
			this.close = this.querySelector(this.selectors.close);
			this.type = this.dataset.type;

			// Methods
			this.init();
		}

		init() {
			const { type } = this;

			if (type === 'drawer') return;

			this.addEventListeners();
		}

		addEventListeners() {
			const { headings, close } = this;

			headings.forEach((heading) => {
				heading.addEventListener('click', (e) => this.handleActiveTab(e));
			});

			close.addEventListener('click', this.handleCloseTab.bind(this));
		}

		handleActiveTab(e) {
			const { selectors, classes } = this;
			const tab = e.target.closest(this.selectors.tabs);

			tab.classList.add(classes.active);
			this.classList.add(classes.hasVisibleTab);

			if (window.innerWidth < 1025) {
				window.scrollTo(0, tab.getBoundingClientRect().top + document.documentElement.scrollTop - 100);
			}
		}

		handleCloseTab() {
			const { tabs, classes } = this;

			this.classList.remove(classes.hasVisibleTab);
			tabs.forEach((tab) => {
				if (tab.classList.contains(classes.active)) tab.classList.remove(classes.active);
			});
		}
	}

	if (!customElements.get('product-tabs')) {
		customElements.define('product-tabs', ProductTabs);
	}
}
